//
//  PageTitle.tsx
//
//  isana.net,inc. Proprietary and Confidential
//

import { Typography } from "@mui/material";

export const PageTitle = ({ title }: { title: string }) => {
  return (
    <Typography variant="h4" sx={{ mt: 2, mb: 2 }}>
      {title}
    </Typography>
  );
};
